import { Tooltip } from '@neo/primitives/tooltip'
import { Image, MessageSquare, Phone, Send } from 'lucide-react'

type Capability = 'voice' | 'sms' | 'mms' | 'whatsapp'

interface CapabilityBadgesProps {
  capabilities?: Capability[]
  voiceEnabled?: boolean
  smsEnabled?: boolean
  mmsEnabled?: boolean
  whatsappEnabled?: boolean
}

const capabilityConfig = [
  { key: 'voice', icon: Phone, label: 'Voice' },
  { key: 'sms', icon: MessageSquare, label: 'SMS' },
  { key: 'mms', icon: Image, label: 'MMS' },
  { key: 'whatsapp', icon: Send, label: 'WhatsApp' },
] as const

export const CapabilityBadges = ({
  capabilities,
  voiceEnabled,
  smsEnabled,
  mmsEnabled,
  whatsappEnabled,
}: CapabilityBadgesProps) => {
  const normalizedCaps = capabilities?.map((c) => c.toLowerCase()) || []
  const enabledCapabilities = capabilityConfig.filter(
    (cap) =>
      normalizedCaps.includes(cap.key) ||
      (cap.key === 'voice' && voiceEnabled) ||
      (cap.key === 'sms' && smsEnabled) ||
      (cap.key === 'mms' && mmsEnabled) ||
      (cap.key === 'whatsapp' && whatsappEnabled),
  )

  if (enabledCapabilities.length === 0) {
    return <span className="text-s-400">—</span>
  }

  return (
    <div className="flex gap-2.5">
      {enabledCapabilities.map((capability) => {
        const Icon = capability.icon
        return (
          <Tooltip key={capability.key} content={capability.label}>
            <div className="flex items-center">
              <Icon className="size-3 text-brand-text" />
            </div>
          </Tooltip>
        )
      })}
    </div>
  )
}
